/**
 * Shared Sentry configuration for filtering third-party errors.
 * This module provides common configuration options to prevent
 * Heatmap, Pinterest, and other third-party script errors from
 * being sent to Sentry.
 */

/**
 * URL patterns to deny from Sentry error reporting.
 * @type {RegExp[]}
 */
export const denyUrls = [
  /ct\.pinterest\.com/,
  /heatmap-project-.*/,
  /ws\.heatmap\.com/,
  /clarity\.ms/,
  /preprocessor\.min\.js/,
  /heatmap/i,
  /pinterest/i
];

/**
 * Filters out errors from third-party scripts (Heatmap, Pinterest, etc.)
 * @param {any} event - The Sentry event (works with both @sentry/browser and @sentry/react)
 * @param {any} hint - Additional event context
 * @returns {any | null} - The event to send, or null to filter it out
 */
export function beforeSend(event, hint) {
  const errorMessage = event.message || hint.originalException?.message || '';
  const stacktrace = event.exception?.values?.[0]?.stacktrace?.frames || [];
  const stacktraceString = JSON.stringify(stacktrace);

  // Check if error is from Heatmap
  if (
    errorMessage.includes('finalTarget') ||
    errorMessage.includes('Heatmap') ||
    stacktraceString.includes('preprocessor.min.js') ||
    stacktraceString.includes('heatmap') ||
    stacktraceString.includes('HeatZipWorker') ||
    stacktraceString.includes('HeatmapTracker')
  ) {
    return null; // Don't send to Sentry
  }

  // Check if error is from Pinterest
  if (
    errorMessage.includes('Pinterest') ||
    stacktraceString.includes('pinterest') ||
    stacktraceString.includes('ct.pinterest.com')
  ) {
    return null; // Don't send to Sentry
  }

  return event;
}

